import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/personal-information-protection-statement/page.tsx");
